import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';
import Main from 'layouts/Main';
import Container from 'components/Container';

// import p1 from 'assests/Photos/NEP/1.jpg' ;
// import p2 from 'assests/Photos/NEP/2.jpg' ;
// import p3 from 'assests/Photos/NEP/3.jpg' ;
// import p4 from 'assests/Photos/NEP/4.jpg' ;
// import p5 from 'assests/Photos/NEP/5.jpg' ;

// import p6 from 'assests/Pdf/mandatory-public-disclosure.pdf'

const NEP2020 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  const [config, setConfig] = useState({ base_image_url: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url}/home/home-static/static-images/all-static-images/NEP/1.webp`;
  const p2 = `${config.base_image_url}/home/home-static/static-images/all-static-images/NEP/2.webp`;
  const p3 = `${config.base_image_url}/home/home-static/static-images/all-static-images/NEP/3.webp`;
  const p4 = `${config.base_image_url}/home/home-static/static-images/all-static-images/NEP/4.webp`;
  const p5 = `${config.base_image_url}/home/home-static/static-images/all-static-images/NEP/5.webp`;
 

  const photos = [
    {
      src: p1,
      source: p1,
      rows: 3,
      cols: 3,
    },
    {
      src: p2,
      source:p2,
      rows: 3,
      cols: 3,
    },
    {
      src: p3,
      source: p3,
      rows: 3,
      cols: 3,
    },
    {
      src: p4,
      source: p4,
      rows: 3,
      cols: 3,
    },
    {
      src: p5,
      source: p5,
      rows: 3,
      cols: 3,
    },
    
    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Main>
    <Container maxWidth={0.78} paddingTop={'0 !important'}>
    <Box>
      <Box display={'flex'} justifyContent={'flex-end'} marginBottom={2}>
        <Button
          color="primary"
          size="large"
          endIcon={
            <svg
              width={16}
              height={16}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          }
          onClick={() => openLightbox(0)}
        >
          Open 
        </Button>
      </Box>
      <Box>
        <ImageList
          variant="quilted"
          cols={3}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Container>
    </Main>
  );
};

export default NEP2020;